var _path, _path2, _circle, _circle2, _circle3, _circle4, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEnrich = function SvgEnrich(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4239 22.4286C18.3814 24.039 15.8029 25 13 25C10.1971 25 7.61863 24.039 5.57612 22.4286M22.8491 19.8571C24.2049 17.9134 25 15.5496 25 13C25 10.3876 24.1652 7.97024 22.7479 6M19.4286 2.8654C17.5703 1.68418 15.365 1 13 1C10.635 1 8.42974 1.68418 6.57143 2.8654M3.1509 6.14286C1.79511 8.08657 1 10.4504 1 13C1 15.3364 1.6677 17.5168 2.82268 19.3609",
    stroke: "#9E9E9E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 20C16.866 20 20 16.866 20 13C20 9.13401 16.866 6 13 6C9.13401 6 6 9.13401 6 13C6 16.866 9.13401 20 13 20Z",
    stroke: "#9E9E9E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 7,
    r: 1,
    fill: "white",
    stroke: "#9E9E9E",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 3,
    r: 1,
    fill: "white",
    stroke: "#9E9E9E",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 19,
    r: 1,
    fill: "white",
    stroke: "#9E9E9E",
    strokeWidth: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 23,
    r: 1,
    fill: "white",
    stroke: "#9E9E9E",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 18C8.49698 17.8465 9.0895 17.2965 9.27439 17.0693C10.1334 16.0136 11.4827 15.3333 13 15.3333C14.5173 15.3333 15.8666 16.0136 16.7256 17.0693C16.841 17.2111 17.1151 17.6732 17.3042 18.038M15.1538 12C15.1538 13.1046 14.1895 14 13 14C11.8105 14 10.8462 13.1046 10.8462 12C10.8462 10.8954 11.8105 10 13 10C14.1895 10 15.1538 10.8954 15.1538 12Z",
    stroke: "#9E9E9E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnrich, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/enrich.1f4aab4b.svg";
export { ForwardRef as ReactComponent };